<div class="chart" [id]="chartId"></div>
